"use client";

import React from "react";
import { MapPin, House, Wind, Store } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const valueProps = [{
  title: "No Bank Required",
  description: "Bypass traditional lending hurdles. We connect you directly with sellers who offer private financing, making homeownership accessible regardless of your credit history.",
  icon: MapPin
}, {
  title: "Nationwide Focus",
  description: "Specialized expertise nationwide. We understand property laws and financing regulations across the country.",
  icon: House
}, {
  title: "Flexible Down Payments",
  description: "Our marketplace features properties with a wide range of entry points. Filter by your available capital to find a home that fits your current financial situation.",
  icon: Wind
}, {
  title: "Fast Closing Process",
  description: "Without the red tape of institutional banks, you can move from offer to keys in a fraction of the time. Secure your future home on your own schedule.",
  icon: Store
}];
export default function WhyChooseOwnerFinancing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257371" id="why-choose-owner-financing" className="dark bg-background text-foreground">
      <div className="bg-background py-20 md:py-28">
        <div className="page-container">
          <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
            <h2 className="text-primary font-semibold tracking-widest text-sm uppercase mb-4 font-default">
              The Private Financing Edge
            </h2>
            <h3 className="text-foreground text-3xl md:text-4xl lg:text-5xl font-bold mb-6 font-default border-b-2 border-primary/30 pb-4 inline-block">
              Why Choose Owner Financing?
            </h3>
            <p className="text-muted-foreground text-lg font-default">
              Dueno a Dueno Homes simplifies the path to property ownership through direct seller-to-buyer relationships.
            </p>
          </div>

          <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            {valueProps.map((item, i) => <Card key={i} data-index={i} className="bg-card border-border/50 p-0 gap-0 items-center text-center shadow-md hover:shadow-xl hover:border-primary/50 transition-all duration-300 rounded-lg">
                <CardHeader className="p-0 pb-6 items-center">
                  <div className="w-16 h-16 rounded-lg bg-primary/10 flex items-center justify-center mb-4 mt-8">
                    <item.icon className="w-8 h-8 text-primary" />
                  </div>
                  <CardTitle className="text-foreground text-xl font-default px-4">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-0 px-6 pb-8">
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {item.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}